import React from "react";
import ReactDOM from "react-dom/client";
import EntryPoint from "./EntryPoint";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <EntryPoint />
    </BrowserRouter>
  </React.StrictMode>
);
